var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "mb-1" },
        [
          _c("b-col", { staticClass: "mt-2", attrs: { md: "12" } }, [
            _c("h4", [
              _vm._v("Drag and drop Leads between columns to update status"),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "mb-3" },
        [
          _c(
            "b-col",
            { attrs: { md: "4" } },
            [
              _c("b-form-input", {
                staticClass: "mr-2",
                attrs: { placeholder: "Search Opportunities..." },
                model: {
                  value: _vm.searchKeyword,
                  callback: function ($$v) {
                    _vm.searchKeyword = $$v
                  },
                  expression: "searchKeyword",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "4" } },
            [
              _c("b-form-select", {
                staticClass: "mr-2",
                attrs: { options: _vm.leadCustomerOptions },
                model: {
                  value: _vm.selectedLeadCustomer,
                  callback: function ($$v) {
                    _vm.selectedLeadCustomer = $$v
                  },
                  expression: "selectedLeadCustomer",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "justify-content-end", attrs: { md: "4" } },
            [
              _c(
                "b-button",
                { attrs: { variant: "primary", to: "/leads/leads-add" } },
                [_vm._v("Add Lead")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex justify-content-center mb-1" },
        [
          _vm.loadingpipe
            ? _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning", block: "" },
              })
            : _vm._e(),
        ],
        1
      ),
      !_vm.loadingpipe
        ? _c("div", { staticClass: "card p-1" }, [
            _c(
              "div",
              { staticClass: "kanban-board" },
              _vm._l(_vm.stages, function (stage, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class: [
                      "kanban-column",
                      "text-center",
                      "p-1",
                      _vm.getStageClass(stage),
                    ],
                  },
                  [
                    _c("h3", [_vm._v(_vm._s(stage))]),
                    _c(
                      "draggable",
                      {
                        staticClass: "list-group",
                        attrs: {
                          list: _vm.filteredTasks[stage],
                          group: "tasks",
                          "data-stage": _vm.stages[index],
                        },
                        on: {
                          end: function ($event) {
                            return _vm.onDragEnd(stage, $event)
                          },
                        },
                      },
                      _vm._l(_vm.filteredTasks[stage], function (task) {
                        return _c(
                          "div",
                          {
                            key: task.id,
                            staticClass: "list-group-item my-2 shadow-sm",
                            attrs: { "data-id": task.id },
                          },
                          [
                            _c("div", { staticClass: "task-title" }, [
                              _vm._v(_vm._s(task.name)),
                            ]),
                            _c("div", { staticClass: "text-center my-1" }, [
                              _vm._v(_vm._s(task.leadclient)),
                            ]),
                            stage !== "NEW"
                              ? _c("div", { staticClass: "task-description" }, [
                                  _vm._v(
                                    " Description: " +
                                      _vm._s(task.description) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                            stage === "NEW"
                              ? _c(
                                  "b-badge",
                                  {
                                    attrs: {
                                      variant: _vm.statusVariant(
                                        task.leadStatus
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          task.leadStatus ? "Client" : "Lead"
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            stage !== "NEW"
                              ? _c("b-form-textarea", {
                                  staticClass: "mt-2",
                                  attrs: {
                                    placeholder: "Add a comment...",
                                    rows: "2",
                                  },
                                  model: {
                                    value: task.comment,
                                    callback: function ($$v) {
                                      _vm.$set(task, "comment", $$v)
                                    },
                                    expression: "task.comment",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }